import s from './ui.module.scss';

export interface SoundToggleProps {
  on: boolean;
  onToggle: () => void;
}

export function SoundToggle({ on, onToggle }: SoundToggleProps) {
  return (
    <button
      type="button"
      className={s.themeToggle}
      onClick={onToggle}
      aria-label={on ? 'Couper le son' : 'Activer le son'}
      title="Son"
    >
      {on ? 'Son' : 'Muet'}
    </button>
  );
}
